export default __webpack_public_path__ + "static/media/arrow-left-circle.5bf27a60.svg";